<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('Search')" class="kh-font" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            {{ record.study_time }}
          </td>
          <td>{{ record.session }}</td>
          <td>{{ record.number_of_session ? moment(record.number_of_session, "D").format('Do') : '' }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.weekday_type ? record.weekday_type.weekday_type : '' }}
            <small>
              {{
                record.weekday_type
                  ? record.weekday_type.is_required_study_time
                    ? ' (Required study time: Yes)'
                    : ' (Required study time: No)'
                  : ''
              }}</small>
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.visible ? 'Yes' : 'No' }}
          </td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="mr-2 text-primary" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a href="#" v-tooltip="'Delete'" class="text-danger" @click.prevent="destroy(record)"
              :disabled="record._deleting">
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="350px">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t('school.academic.operation.classOperation.weekdayType') }}</label>
            <a-select v-model="weekday_type_id" :options="weekday_types" showSearch mode="multiple" :filterOption="(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')" style="width: 100%;" />

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t('studyTime.session') }}</label>
            <a-select v-model="session" :options="shifts" showSearch mode="multiple"
              :filterOption="(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')" style="width: 100%;" />

          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  props: ['fetch'],
  name: 'study-time-table',
  data() {
    return {
      loading: false,
      visible: false,
      weekday_type_id: [],
      weekday_types: [],
      session: [],
      shifts: [],
      columns: [
        { name: this.$t('studyTime.studyTime') },
        { name: this.$t('studyTime.session') },
        { name: this.$t('studyTime.numberOfSession') },
        {
          name: this.$t('school.academic.operation.classOperation.weekdayType'),
          style: 'text-align:center'
        },
        { name: this.$t('studyTime.visible'), style: 'text-align:center' },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1px'
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.getWeekdayType()
    this.getSession()
  },
  computed: {
    ...mapState('studyTime', ['resources', 'pagination',]),
    ...mapActions('studyTime', ['paymentShift']),
    search: {
      get() {
        return this.$store.state.studyTime.search
      },
      set(newValue) {
        this.$store.commit('studyTime/SET_SEARCH', newValue)
        this.$store.commit('studyTime/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    moment,
    fetchData(attributes = {}) {
      this.loading = true

      const params = {
        search: this.search,
        weekday_type_id: Array.isArray(this.weekday_type_id)
          ? this.weekday_type_id
          : [this.weekday_type_id],
        session: Array.isArray(this.session)
          ? this.session
          : [this.session],
        ...attributes
      }

      this.$store
        .dispatch('studyTime/fetch', params)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    getWeekdayType() {
      this.$store
        .dispatch('studyTime/paymentShift')
        .then(response => {
          this.weekday_types = response.weekday_types.map(el => ({
            value: el.id,
            label: `${el.weekday_type} ${el.is_required_study_time ? '(Required study time: Yes)' : '(Required study time: No)'}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    getSession() {
      this.$store.dispatch('studyTime/paymentShift')
        .then(response => {
          const uniqueSessions = []
          response.payment_shifts.forEach(el => {
            if (el.shift_en && !uniqueSessions.includes(el.shift_en)) {
              uniqueSessions.push(el.shift_en)
            }
          })

          this.shifts = uniqueSessions.map(el => ({
            value: el,
            label: el
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('studyTime/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'study-time-edit',
        params: { id: record.ac_st_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('studyTime/destroy', record.ac_st_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),

    fetch: function () {
      this.fetchData()
      this.$emit('fetched')
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        weekday_type_id: this.weekday_type_id,
        session: this.session
      })
    }, 500),

    weekday_type_id: debounce(function (value) {
      this.fetchData({
        search: this.search,
        weekday_type_id: value,
        session: this.session
      })
    }, 500),

    session: debounce(function (value) {
      this.fetchData({
        search: this.search,
        weekday_type_id: this.weekday_type_id,
        session: value
      })
    }, 500)
  }

}
</script>
